define('modules/form_editor/models/dropdown',['require','exports','module','./base_form_element','./dropdown_item'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element"),
      DropDownItem = require("./dropdown_item");

  var Controller = {
    addItem: function(attrs){
      var newItem = this._createNewItem(attrs);
      this.addItemAfter(null, newItem);
    },

    addItemAfter: function(ref, model){
      var pos = this.items.indexOf(ref)+1 || this.items.length;
      var theModel = model || this._createNewItem();
      this.items.add(theModel, {at: pos});
      this.items.trigger("sort");

    },

    removeItem: function(model){
      //keep at least one
      if(this.items.length > 1){
        this.items.remove(model);
      }
    },

    clone: function(){
      var copy = module.exports.__super__.clone.apply(this);
      copy.items.reset([]);
      this.items.each(function(item){
        copy.items.add(item.clone());
      }, this);
      return copy;
    },

    setFirstOptionInvalid: function(value){
      this.set("firstOptionInvalid", value);
      this.items.first().set("valid", !value);
      this.items.trigger("sort");
    },

    _createNewItem: function(attrs){
      //(attrs && attrs.text) || _.extend(attrs || {}, { text: ITEM_DEFAULT_TEXT});
      return new DropDownItem(attrs || {});
    }
  };

  module.exports = BaseFormElement.extend({
    name: "input:dropdown",

    defaultValues: {
      firstOptionInvalid: true,
      url: ''
    },

    initialize: function(attrs,options){
      options = options || {};
      module.exports.__super__.initialize.call(this,attrs,options);
      this.items = new Backbone.Collection(attrs.items || [], {
        model: options.itemModel || DropDownItem
      });

      if(this.items.length === 0){
        this.addItem({
          valid: !this.get("firstOptionInvalid")
        });
      }
    }
  });

  _.extend(module.exports.prototype, Controller);
});

